export const DEFAULT_SESSION_FEE = 1000;

export function getPartnerFee(config) {
  const partnerFee = Number.parseInt(config?.fees, 10);
  return Number.isNaN(partnerFee) ? DEFAULT_SESSION_FEE : partnerFee;
}

export function isPartnerPage(partnerSlug) {
  return Boolean(String(partnerSlug || "").trim());
}

export function getSessionFee({ partnerSlug, config }) {
  if (isPartnerPage(partnerSlug)) {
    return getPartnerFee(config);
  }

  return DEFAULT_SESSION_FEE;
}

export function getStrikePrice(sessionFee) {
  const fee = Number(sessionFee) || DEFAULT_SESSION_FEE;
  return fee <= 899 ? fee + 100 : fee + 200;
}

export const DEFAULT_STRIKE_PRICE = getStrikePrice(DEFAULT_SESSION_FEE);
